export default __webpack_public_path__ + "static/media/drawingIcon.6e76647d.svg";